import { useState, useRef, useEffect } from "react";
import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import DeviceService from "../../Services/DeviceService";
import { ReactComponent as AddIcon } from '../../Assets/img/AddIcon.svg';
import { ReactComponent as CheckBoxUnselected } from '../../Assets/img/CheckBoxUnselected.svg';
import { ReactComponent as CheckBoxSelected } from '../../Assets/img/CheckBoxSelected.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';
import { ReactComponent as Error } from '../../Assets/img/Error.svg';

/**
 * Renders add device pop up to create device
 * @component
 * @param {Event} props.onClose() To close pop up
 * @param {Event} props.onShowMessage("message") To show message in pop up
 */
function AddDevice(props) {

    //#region States

    const [isActive, setIsActive] = useState(true);
    const [isForRegistration, setIsForRegistration] = useState(false);
    const [DeviceModels, setDeviceModels] = useState([]);
    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);

    //#endregion

    //#region Refs

    const deviceModelIdRef = useRef();
    const deviceNameRef = useRef();
    const serialNumRef = useRef();

    //#endregion

    //#region useEffect hook

    /**
    * Calls device service to fetch device models
    * Runs only on the first render
    */
    useEffect(() => {
        DeviceService.GetDeviceModels().then((getDeviceModelResponse) => {
            if (getDeviceModelResponse.response == null) {
                setError(getDeviceModelResponse.errors[0].message);
            } else {
                setDeviceModels(getDeviceModelResponse.response);
            }
        }).catch((err) => {
            setError(err.data);
        });
    }, [])

    //#endregion

    //#region Add device

    /**
    * Calls device service to create device
    * @param   {Event} event  User action (on submitting form)
    */
    async function addDevice(event) {
        event.preventDefault();

        let DeviceDetailDTO = {
            DeviceModelId: deviceModelIdRef.current.value,
            Name: ((deviceNameRef.current.value === "") ? null : deviceNameRef.current.value),
            SerialNum: ((serialNumRef.current.value === "") ? null : serialNumRef.current.value),
            IsActive: isActive,
            IsItForRegistration: isForRegistration,
        };

        DeviceService.CreateDeviceDetail(DeviceDetailDTO)
            .then((response) => {
                if (response.response == null) {
                    setError(response.errors[0].message);
                    setMessagePopup(true);
                } else {
                    props.onClose();
                    props.onShowMessage("Device created sucessfully.");
                }
            })
            .catch((err) => {
                setError(err.data);
                setMessagePopup(true);
            });
    }

    //#endregion

    return (
        <Modal centered={true} contentClassName="AddDeviceMain" show={true} onHide={props.onClose}>

            <ModalHeader className="AddDeviceHeader" style={{ border: "none" }} closeButton >
                <ModalTitle className="Header">
                    <strong>Add Device</strong>
                </ModalTitle>
            </ModalHeader>
            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && (
                    <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                )}
                <form onSubmit={addDevice}>
                    <div style={{ padding: '3%' }}>
                        <div>
                            <label for="DeviceModel" className="label">Device Model</label>
                            <div>
                                <select className="InputField" ref={deviceModelIdRef} required>
                                    <option value="" selected >-Select-</option>
                                    {DeviceModels?.map((DeviceModel) => (
                                        <option value={DeviceModel.Id}>{DeviceModel.Make}-{DeviceModel.Model}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="DeviceName" className="label" >Device Name</label>
                            <div>
                                <input type="text" className="InputField" placeholder="-Text-" min="0" maxlength="30" ref={deviceNameRef} required />
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="SerialNo" className="label">Serial No</label>
                            <div>
                                <input type="text" min="0" maxlength="100" className="InputField" placeholder="-Text-" ref={serialNumRef} required />
                            </div>
                        </div>
                        <br />
                        <div style={{ display: "none" }}>
                            {isForRegistration === false ?
                                (<CheckBoxUnselected onClick={() => setIsForRegistration(true)} className="Checkbox" />)
                                : (<CheckBoxSelected onClick={() => setIsForRegistration(false)} className="Checkbox" />)}
                            <label for="IsForRegistration" className="label">Is For Registration?</label>
                        </div>
                    </div>

                    <ModalFooter className="AddDeviceFooter" style={{ border: "none" }}>
                        <div>
                            <button type="reset" className="secondary-button" onClick={() => {
                                setIsActive(true); setIsForRegistration(false);
                            }}>
                                <span className="secondary-button-icon"><ResetIcon /></span>
                                <span className="secondary-button-text">Reset</span>
                            </button>
                            &nbsp;
                            <button type="submit" className="primary-button ">
                                <span className="primary-button-icon"><AddIcon /></span>
                                <span className="primary-button-text">Add Device</span>
                            </button>

                        </div>
                    </ModalFooter>
                </form>
            </Modal.Body>

        </Modal >
    );
}

export default AddDevice;